import whatsappIcon from '../assets/whatsapp.svg';

export default function WhatsAppButton() {
  const whatsappNumber = '+919267633372'; // Kinder Heaven contact
  const whatsappMessage = 'Hello! I am interested in Kinder Heaven (After-School Program) for my child. Can you provide me with more information about your programs?';

  const handleWhatsAppClick = () => {
    const encodedMessage = encodeURIComponent(whatsappMessage);
    const whatsappURL = `https://wa.me/${whatsappNumber.replace(/\D/g, '')}?text=${encodedMessage}`;
    window.open(whatsappURL, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 z-40 bg-purple-primary hover:bg-purple-dark text-white rounded-full p-4 shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300 flex items-center justify-center float-animation"
      title="Chat with us on WhatsApp"
    >
      <img src={whatsappIcon} alt="WhatsApp" className="w-7 h-7" />
    </button>
  );
}
